<template>
  <button
    :class="classnames"
    :disabled="isDisabled"
    :type="type"
    @click="handleClick"
  >
    <button-style
      :appearance="appearance"
      :isActive="isActive"
      :isDisabled="isDisabled"
    >
      <span v-if="$slots.text" :class="`${ns}__text`">
        <slot name="text" />
      </span>
      <span v-if="$slots.icon" :class="`${ns}__icon`">
        <slot name="icon" />
      </span>
    </button-style>
  </button>
</template>

<script>
  import ButtonStyle from '@/components/ButtonStyle'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'vue-button'

  export default {
    name: 'VueButton',
    mixins: [ bem ],
    props: {
      appearance: {
        default: 'default',
        type: String
      },
      direction: {
        default: 'ltr',
        type: String,
        validator: function (value) {
          return [
            'ltr',
            'rtl'
          ].indexOf(value) !== -1
        }
      },
      isActive: {
        type: Boolean
      },
      isDisabled: {
        type: Boolean
      },
      type: {
        default: 'button',
        type: String,
        validator: function (value) {
          return [
            'button',
            'submit',
            'reset'
          ].indexOf(value) !== -1
        }
      }
    },
    components: {
      'button-style': ButtonStyle
    },
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers () {
        const direction = this.direction

        return [ direction ]
      },
      handleClick () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/VueButton.vue